module.exports = __webpack_public_path__ + "img/icono_informacion.fd3a160c.jpg";